import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-financial-statement',
  templateUrl: './financial-statement.component.html',
  styleUrls: ['./financial-statement.component.scss']
})
export class FinancialStatementComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
